import { Heading,Text } from '@chakra-ui/layout';
import React,{useState} from 'react';
import style from './cart.module.css';
const S = () => {
   
    return <div>


    </div>
  
}



export default S;